module.exports = __webpack_public_path__ + "img/return.cfdba2c9.svg";